import RestrictionDetails from "./RestrictionDetails";
export default RestrictionDetails;
